const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
]

// Change display format of date to format required by server:
export function formatDate (month, year) {
  if (!month && !year) return ''
  // Return invalid date if one of the values is missing
  // Used to handle validation server side
  month = !month ? 123 : ('0' + month.toString()).slice(-2)
  year = !year ? 12345 : year
  return year + '-' + month + '-01'
}

// Change format required by server to display readable format of date:
export function formatToReadableDate (month, year) {
  if (!month || !year) return ''
  return monthNames[month - 1] + ' ' + year
}

// Change display format of date to format required by server:
export function formatCalendarDate (dateString) {
  if (!dateString) return ''

  const dateParts = dateString.split('/')
  if (dateParts.length < 3) return ''

  const day = ('0' + dateParts[0]).slice(-2)
  const month = ('0' + dateParts[1]).slice(-2)
  const year = dateParts[2]

  return year + '-' + month + '-' + day
}

export function formatToReadableCalendarDate (dateString, includeDay = false) {
  if (!dateString) return ''

  const dateParts = dateString.split('/')
  if (dateParts.length < 3) return ''
  const month = (dateParts[1]).slice(-2)
  const year = dateParts[2]

  if (includeDay) {
    return dateParts[0] + ' ' + monthNames[month - 1] + ' ' + year
  }

  return monthNames[month - 1] + ' ' + year
}

// Get todays date as string to limit date datepicker selectable dates:
export function getTodaysDate () {
  const todaysDate = new Date()
  return todaysDate.getDate() + '/' + (todaysDate.getMonth() + 1) + '/' + todaysDate.getFullYear()
}
